import { render, staticRenderFns } from "./ot-organisation-user-contracts-index.vue?vue&type=template&id=2223abdc&scoped=true&"
import script from "./ot-organisation-user-contracts-index.vue?vue&type=script&lang=ts&"
export * from "./ot-organisation-user-contracts-index.vue?vue&type=script&lang=ts&"
import style0 from "./ot-organisation-user-contracts-index.vue?vue&type=style&index=0&id=2223abdc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2223abdc",
  null
  
)

export default component.exports